/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Row_Delete_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not delete the row." |
*
* @param {Datasets_Row_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_row_delete_error = /** @type {((inputs?: Datasets_Row_Delete_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Row_Delete_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zeile konnte nicht gelöscht werden.")
	return /** @type {LocalizedString} */ ("Could not delete the row.")
});